import {Injectable} from "@angular/core";
import {FirebaseProvider} from "../../providers/firebase/firebaseProvider";
import {Center} from "../../models/center/center.interface";
import {Doctor} from "../../models/doctor/doctor.interface";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {Patient} from "../../models/patient/patient.interface";
import {Entry} from "../../models/entry/entry.interface";

@Injectable()
export class AdminService {

    private centerList = new BehaviorSubject<Center[]>([]);
    private doctorList = new BehaviorSubject<Doctor[]>([]);
    private patientList = new BehaviorSubject<Patient[]>([]);

    constructor(private firebaseProvider: FirebaseProvider) {

    }

    getCenters(): Subject<Center[]> {
        return this.centerList;
    }

    fetchCenters() {
        this.firebaseProvider.getCenters().subscribe((cList) => {
            //console.log("in adminService.getCenterList() ---> cList length: " + cList.length);
            this.centerList.next(cList);

        }, error => console.log("ERROR:" + error));
    }

    getDoctors(): Subject<Doctor[]> {
        return this.doctorList;
    }

    fetchDoctors() {
        this.firebaseProvider.getDoctors().subscribe((dList) => {
            //console.log("in adminService.getDoctorLIst() ---> cList length: " + dList.length);
            this.doctorList.next(dList);
        });
    }

    getPatients(): Subject<Patient[]> {
        return this.patientList;
    }

    fetchPatients() {
        this.firebaseProvider.getPatients().subscribe((pList) => {
            //console.log("in adminService.fetchPatients() ---> pList length: " + pList.length);
            this.patientList.next(pList);
        });
    }

    deleteCenter(center: Center): Observable<void> {
        return this.firebaseProvider.deleteCenter(center);
    }

    updateCenter(center: Center): Observable<void> {
        return this.firebaseProvider.updateCenter(center);
    }

    updateDoctor(doctor: Doctor): Observable<void> {
        return this.firebaseProvider.updateDoctor(doctor);
    }

    getEntriesForPatient(patient: Patient, numberOfDays: number): Observable<Entry[]> {
        return this.firebaseProvider.getEntries(patient["$key"], numberOfDays);
    }
}



// WEBPACK FOOTER //
// ./src/pages/admin/adminService.ts